export default "__VITE_ASSET__BZG5eLf3__"